import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';
import { AppConstants } from '../constants.service';

export interface CurrentUser {
  permissions: Record<string, string[]>;
  menu_permissions?: string[];
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private accessToken = '';
  private currentUser?: Observable<CurrentUser>;

  constructor(private http: HttpClient, private authService: AuthService) {}

  load(): Observable<CurrentUser> {
    const token = this.authService.getAccessToken();
    if (!this.currentUser || this.accessToken !== token) {
      this.accessToken = token;
      this.currentUser = this.http.get<CurrentUser>(AppConstants.baseUrl + '/users/me').pipe(
        tap(user => {
          const permissions = Object.fromEntries(Object.entries(user.permissions || {})
            .map(([entity, actions]) => [this.normalize(entity), actions]));
          window.localStorage.setItem('permissions', JSON.stringify(permissions));
          window.localStorage.setItem('entities', Object.keys(permissions).join(','));
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.currentUser;
  }

  allowed(user: CurrentUser, entity: string, action?: string): boolean {
    const normalized = this.normalize(entity);
    const key = Object.keys(user.permissions || {}).find(candidate => this.normalize(candidate) === normalized);
    if (!key) return false;
    const actions = user.permissions[key] || [];
    return action ? actions.includes(action) : actions.some(value => ['index', 'read', 'show', 'create', 'update'].includes(value));
  }

  private normalize(entity: string): string {
    return entity.replace(/_/g, '').toUpperCase();
  }
}
